import styled from '@emotion/styled';

import { OutlineButton, PrimaryButton } from '@/components/common/Button/style';

export const ModalPrimaryButton = styled(PrimaryButton)`
	width: 100%;
`;

export const ModalSecondaryButton = styled(OutlineButton)`
	width: 100%;
	border-color: ${(props) => props.theme.ui.border.default};
	color: ${(props) => props.theme.ui.text.secondary};
	background-color: ${(props) => props.theme.ui.surface.subtle};

	&:hover:not(:disabled) {
		background-color: ${(props) => props.theme.ui.interactive.hoverWash};
		border-color: ${(props) => props.theme.ui.border.default};
		color: ${(props) => props.theme.ui.text.primary};
	}
`;
